var map = {
	"./Again.svg": 6939,
	"./Android.svg": 41743,
	"./Arrow-Down.svg": 12132,
	"./Arrow-Down2.svg": 74550,
	"./Arrow-Down3.svg": 26685,
	"./Arrow-Right.svg": 88749,
	"./BackArrow.svg": 46275,
	"./Close.svg": 48102,
	"./Cloud-PayS.svg": 46020,
	"./Cloud-Purchased.svg": 37565,
	"./Cur-Chose.svg": 7880,
	"./DialogClose.svg": 43012,
	"./Edit-Head.svg": 23012,
	"./Icon-Success.svg": 35991,
	"./Icon-Warning.svg": 24315,
	"./Icon-Warning2.svg": 83879,
	"./Invoice-Success.svg": 88328,
	"./Login-Code.svg": 96803,
	"./Login-Phone.svg": 42344,
	"./Login-Pwd.svg": 42396,
	"./Login-PwdHide.svg": 60562,
	"./Login-PwdShow.svg": 16708,
	"./Login-User.svg": 77649,
	"./Msg-Error.svg": 25747,
	"./Msg-Success.svg": 69705,
	"./Msg-Warning.svg": 10856,
	"./Not-LoginAvatar.svg": 76330,
	"./Pay-Success.svg": 78395,
	"./Qrcode-Border.svg": 54055,
	"./Qydb-Icon1.svg": 12267,
	"./Qydb-Icon2.svg": 8867,
	"./Qydb-Icon3.svg": 80555,
	"./Qydb-Icon4.svg": 71099,
	"./Qydb-Icon5.svg": 36215,
	"./Scan-Border.svg": 79639,
	"./Scan-Success.svg": 75953,
	"./Select-Hover.svg": 63457,
	"./Select-No.svg": 88926,
	"./Select-Yes.svg": 38167,
	"./Selected.svg": 57461,
	"./ThreeD.svg": 61954,
	"./Tips-Error.svg": 86885,
	"./Vip-Had.svg": 34610,
	"./Vip-Not.svg": 71511,
	"./Vip-SonnDue.svg": 98762,
	"./Windows.svg": 2183,
	"./arrowclose.svg": 39270,
	"./bbuy.svg": 61036,
	"./cad-phone-hover.svg": 62497,
	"./cad-phone.svg": 78732,
	"./cad-top-hover.svg": 86729,
	"./cad-top.svg": 38308,
	"./cad-wx-hover.svg": 46398,
	"./cad-wx.svg": 83882,
	"./checked.svg": 8433,
	"./circlecheck.svg": 96428,
	"./digclose.svg": 30316,
	"./expend.svg": 45338,
	"./galleryvip.svg": 5362,
	"./geryRight.svg": 83637,
	"./iOS.svg": 79933,
	"./minivip.svg": 18666,
	"./noCheck.svg": 31052,
	"./phone.svg": 64397,
	"./qyicon.svg": 21844,
	"./right-bg.svg": 52310,
	"./right.svg": 69506,
	"./sdk.svg": 60425,
	"./supervip.svg": 49410,
	"./threevip.svg": 59155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79409;